module.exports = __webpack_public_path__ + "img/temp-no-posts-icon.63febb37.svg";